import { Box, Divider, Typography } from "@mui/material";
import { format } from "date-fns";

const Metadata = ({ data }) => {
  // Safely access data properties
  const {
    callStatus,
    caller = "N/A",
    callerCountry,
    called = "N/A",
    calledCountry,
    calledAt,
    callDuration,
    isMachineOrVoicemail = false,
  } = data || {};

  // Format phone numbers with country code if available
  const callerDisplay = callerCountry ? `${caller} (${callerCountry})` : caller;
  const calledDisplay = calledCountry ? `${called} (${calledCountry})` : called;

  // Format date if available
  const formattedDate = calledAt ? format(new Date(calledAt), "MM/dd/yyyy, hh:mm:ss a") : "N/A";

  const getCallStatus = (status) => {
    switch (status) {
      case "completed" :
         return "Completed";
      case "done":
        return "Completed";
      case "failed":
        return "Failed";
      case "busy":
        return "Busy";
      case "no-answer":
        return "No Answer";
      case "in-progress":
        return "In Progress";
      default:
        return status || "Unknown";
    }
  };

  const getCallStatusColor = (status) => {
    switch (status) {
      case "completed":
        return "#00AA38"; // Green for success
      case "done":
        return "#00AA38"; // Green for success
      case "failed":
        return "#FF0000"; // Red for failure
      case "busy":
        return "#FF8C00"; // Darker orange
      case "no-answer":
        return "#8B008B"; // Dark magenta for missed
      case "in-progress":
        return "#1E90FF"; // Dodger blue for active
      default:
        return "#000000"; // Black as fallback
    }
  };

  const formatCallDuration = (timeInSeconds) => {
    if (!timeInSeconds && timeInSeconds !== 0) return "N/A";

    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;
    return `${minutes}m ${seconds}s`;
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
      aria-label="Call overview"
    >
      <DataRow
        label="Call Status"
        value={getCallStatus(callStatus)}
        valueProps={{
          fontWeight: "bold",
          sx: { color: getCallStatusColor(callStatus) },
          "aria-label": `Call status: ${getCallStatus(callStatus)}`,
        }}
      />

      {isMachineOrVoicemail && (
        <DataRow
          label="Machine or Voicemail Detected"
          value="Yes"
          valueProps={{
            fontWeight: "bold",
            sx: { color: "#FF0000" },
            "aria-label": "Machine or voicemail detected",
          }}
        />
      )}

      <DataRow label="Caller Phone Number" value={callerDisplay} />

      <DataRow label="Called Phone Number" value={calledDisplay} />

      <DataRow label="Called At" value={formattedDate} />

      <DataRow label="Call Duration" value={formatCallDuration(callDuration)} />
    </Box>
  );
};

export default Metadata;

const DataRow = ({ label, value, valueProps = {} }) => (
  <>
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        padding: 1,
        alignItems: "center",
      }}
    >
      <Typography variant="body2" sx={{color:theme=>theme.palette.text.primary}}>{label}</Typography>
      <Typography variant="body1" sx={{color:theme=>theme.palette.text.primary}} {...valueProps}>
        {value}
      </Typography>
    </Box>
    <Divider variant="fullWidth" />
  </>
);
